import { /*fetchSoundsMock,*/ fetchSoundsWithoutGroups } from "./mock";
import { callApi, SERVER_TYPES } from "@amplio-common/api";
import { SINGLE_WORD_LIMIT, SOUNDS_MAPPER } from "./constants";

export const fetchCategoriesPromise = () =>
  new Promise((resolve, reject) => {
    const processResponse = response => {
      const items = [];
      const groups = response.map(category => ({
        // ...category,
        label: category.name,
        id: category.id,
        value: category.id,
        items: category.sub_categories,
      }));
      groups.forEach(group => {
        group.value = `g-${group.id}`;
        group.items = group.items.map((item) => ({
          id: `${item}_${group.id}`,
          value: `i-${item}${group.id}`,
          label: item,
          name: item,
        }));
        group.itemsData = group.items;
        const singleItems = group.items.map(item => ({ ...item, label: `${item.label} (${group.label})`, category: group.label, category_id: group.id }));
        items.push(...singleItems);
      });
      const options = [
        { label: "Categories", options: groups },
        { label: "Subcategory", options: items },
      ];
      return {
        groups,
        options,
        items,
      };
    };
    callApi(
      "vocabulary/category/",
      { method: "GET" },
    ).then(
      ({ response }) => resolve(processResponse(response)),
      error => reject(error),
    );
  });

export const fetchSoundsPromise = () => Promise.resolve(
  // fetchSoundsMock(), relevant if/when the multiple groups and sounds will return
  fetchSoundsWithoutGroups(),
);

/*
export const generateGameUUID = ({ studentId, gameType, filters, therpistId, treatmentId, area, game_id }) =>
  new Promise((resolve, reject) => {
    const body = {
      task: {
        student_id: studentId,
        therapist_id: therpistId,
        treatment_id: treatmentId,
        task_type: gameType,
        h5p_game_id: game_id,
      },
    };

    if (filters) {
      body.task.filters = filters;
      body.task.syllables = filters?.number_of_syllables;
    }
    if (area) {
      body.task.area = area;
    }

    callApi("measurements/", { method: "POST", type: "JSON", body }, undefined, SERVER_TYPES.ANALYTICS).then(({ response }) => {
      resolve({ uuid: response?.uuid, taskType: response?.task_type, error: undefined });
    }).catch(
      () => { reject(new Error("failed fetching from analytics server")); },
    );
    //   // error => resolve(error),
    //   // error => resolve({ uuid: "1", taskType: "2", error: undefined }),
    // );
  });
*/

const soundFilters = (filters) => {
  const items = filters?.articulation?.items;
  const newItems = [];
  if (items) {
    items.forEach(item => {
      SOUNDS_MAPPER[item.sound].forEach(phonem => {
        const newItem = { ...item };
        newItem.sound = phonem;
        newItems.push(newItem);
      });
    });
  }
  return newItems;
};

export const fetchWordsByFilter = ({ filters, limit }) => new Promise((resolve, reject) => {
  const body = filters ? {
    filters,
    limit,
  } : { limit };
  filters.articulation.items = soundFilters(filters);
  callApi(
    "vocabulary/word/",
    { method: "POST", body },
  ).then(
    ({ response }) => resolve({ response }),
    error => reject(error),
  );
});

export const fetchSingleWordByFilter = ({ filters }) => new Promise((resolve, reject) => {
  const body = filters ? {
    filters,
    limit: SINGLE_WORD_LIMIT,
  } : { limit: SINGLE_WORD_LIMIT };
  filters.articulation.items = soundFilters(filters);
  callApi(
    "vocabulary/word/",
    { method: "POST", body },
  ).then(
    ({ response }) => resolve({ response }),
    error => reject(error),
  );
});

export const sendToMeasurementsWithParams = (params) => new Promise((resolve, reject) => {
  callApi(
    "measurements/",
    { method: "POST", body: params, type: "JSON" },
    undefined,
    SERVER_TYPES.ANALYTICS,
  ).then(
    ({ response }) => resolve({ response }),
    error => reject(error),
  );
});

export const generateGamePromise = (data) => callApi("h5p-games/game-map/", { method: "POST", body: data });
export const fetchGamesPromise = (data) => {
  let url = "h5p-games/?";
  // add the array gameIds to the url
  if (data?.gameIds && data?.gameIds?.length) { url = `${url}&game_id=[${data?.gameIds}]`; }
  if (data?.areaOfNeed) { url = `${url}&field=${data?.areaOfNeed}`; }
  if (data?.protocol) { url = `${url}&protocol=${data?.protocol}`; }
  if (data?.grades && data?.grades?.length) { url = `${url}&grade=${data?.grades}`; }
  if (data?.themes && data?.themes?.length) { url = `${url}&theme=${data?.themes}`; }
  if (data?.ccss && data?.ccss?.length) { url = `${url}&ccss=${data?.ccss}`; }
  return callApi(url, { method: "GET" });
};
export const fetchAreaOfNeedsPromise = () => callApi("fields/", { method: "GET" });

export const fetchThemesPromise = () => callApi("themes/", { method: "GET" });
export const fetchGradesPromise = () => callApi("grades/", { method: "GET" });
export const fetchCCSSMetaPromise = () => callApi("ccs/meta/", { method: "GET" });

export const fetchGamesListPromise = ({ studentId, filters }) =>
  new Promise((resolve, reject) => {
    callApi(
      "games/",
      {
        method: "POST",
        body: {
          studentId,
          filters,
        },
      },
    ).then(
      ({ response }) => resolve(response),
      error => reject(error),
    );
  });


export const getReadingGamePromise = (readingExternalId) => new Promise((resolve, reject) => {
  callApi(
    `reading-tasks/${readingExternalId}/`,
    { method: "GET" },
  ).then(
    ({ response }) => resolve({ response: { ...response, id: readingExternalId } }),
    (error) => {
      //resolve({ response: READING_GAMES_MOCK[readingTaskId] });
      reject(error);
    },
  );
});

export const getSpellingGamePromise = (spellingExternalId) => new Promise((resolve, reject) => {
  callApi(
    `spelling-tasks/${spellingExternalId}/`,
    { method: "GET" },
  ).then(
    ({ response }) => resolve({ response: { ...response, id: spellingExternalId } }),
    (error) => {
      reject(error);
    },
  );
});
